import { SwmShell } from "./components/shell";
import { ToastContainer } from "./components/Toast";
import { useAuth } from "./hooks/useAuth";
import { LoginPage } from "./views/auth/LoginPage";
import { Loader2 } from "lucide-react";

/**
 * Main App Component
 *
 * Renders the shell layout with sidebar and header.
 * The Shell component handles navigation, tenant branding, and theme switching.
 */
function App() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <>
      <SwmShell />
      <ToastContainer />
    </>
  );
}

export default App;
